import WarpElement from '@warp-ds/elements-core';
import { css, html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '@warp-ds/elements/components/button';
import { Phone, ProfileType } from '../../server/types.js';

@customElement('grouped-actions')
export class GroupedActions extends WarpElement {
	@property({ type: String }) orgName!: string;
	@property({ type: String }) contactUsUrl?: string;
	@property({ type: String }) externalItemLink?: string;
	@property({ type: ProfileType }) profileType?: ProfileType;
	@property({ type: String }) adId!: string;
	@property({ type: Array }) phone?: Phone[];
	@property({ type: String }) deviceType?: string;

	static styles = [
		...WarpElement.styles,
		css`
			@css-placeholder-OwE2Yr;
		`,
	];

	@state()
	private observer: IntersectionObserver | undefined = undefined;

	isBigScreen = () => {
		return window.innerWidth >= 768;
	};

	fireStateChangeEvent = (entry: IntersectionObserverEntry | undefined) => {
		if (
			entry &&
			(this.isBigScreen() || this.profileType !== ProfileType.Standard)
		) {
			const showActionsEvent = new CustomEvent<{ visible: boolean }>(
				'action-visibility-change',
				{
					detail: {
						visible: !entry.isIntersecting && entry.boundingClientRect.top < 0,
					},
				},
			);
			window.dispatchEvent(showActionsEvent);
		}
	};

	observeCTAVisibility = () => {
		this.observer = new IntersectionObserver(
			(entries) => {
				this.fireStateChangeEvent(entries[0]);
			},
			{
				rootMargin: '0px',
				threshold: 0.1,
			},
		);
		this.observer?.observe(this);
	};

	connectedCallback(): void {
		super.connectedCallback();
		this.observeCTAVisibility();
	}

	disconnectedCallback(): void {
		this.observer?.disconnect();
	}

	render() {
		return html`
			<div
				class="${this.profileType === ProfileType.Standard
					? 'hidden md:flex'
					: 'flex'} flex-col gap-16"
			>
				<contact-button
					.contactUsUrl=${this.contactUsUrl}
					.profileType=${this.profileType}
				></contact-button>
				${this.externalItemLink
					? html`
							<external-item-link
								.orgName=${this.orgName}
								.externalItemLink=${this.externalItemLink}
								.variant=${this.contactUsUrl ? 'secondary' : 'primary'}
							></external-item-link>
						`
					: nothing}
				${(!this.contactUsUrl || !this.externalItemLink) && this.phone?.length
					? html`
							<phonenumber-button
								variant=${this.contactUsUrl || this.externalItemLink
									? 'secondary'
									: 'primary'}
								.adId=${this.adId}
								.phone=${this.phone[0]}
								.orgName=${this.orgName}
								.deviceType=${this.deviceType}
							></phonenumber-button>
						`
					: nothing}
			</div>
		`;
	}
}
